import { Component } from "react";
import PropTypes from "prop-types";
import { sendWebContextMessage } from "asos-web-secure-script-container";
import loadSecureScriptContainer from "./loadSecureScriptContainer";
import setupEvents from "./setupEvents";

class SecureScriptContainer extends Component {
  static propTypes = {
    isContainerEnabled: PropTypes.bool,
    webContext: PropTypes.object
  };

  componentDidMount() {
    setupEvents();
  }

  componentDidUpdate() {
    sendWebContextMessage(this.props.webContext);
    loadSecureScriptContainer();
  }

  render() {
    return null;
  }
}

export default SecureScriptContainer;
